import { render, staticRenderFns } from "./TaxGroupForm.vue?vue&type=template&id=594951f1&"
import script from "./TaxGroupForm.vue?vue&type=script&lang=js&"
export * from "./TaxGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports